import Widget from '@/plugins/dashboard/widgets/Invoice/Widget'
import Configure from '@/plugins/dashboard/widgets/Invoice/Configure'
import Chart from '@/plugins/dashboard/classes/Chart'

export default class extends Chart {
  static name = 'Invoice'
  static widget = Widget
  static configure = Configure
}
